<template>
  <v-col
    class="small-book-form"
    column
    align-content-start
    style="height: 100%; padding: 0 !important;"
  >
    <v-col>
      <v-flex>
        <BusinessCustomerDetailsInput
          :bookingForm="bookingForm"
          :hideAuthorizedBy="true"
        />
      </v-flex>
      <v-flex px-2 pb-1>
        <v-layout row>
          <v-divider style="margin-left: 12px; margin-bottom: 5px"></v-divider>
        </v-layout>
      </v-flex>
      <v-layout row wrap align-start>
        <v-flex pt-1 shrink
          ><v-icon
            v-on:click="customiseLocationOld(bookingForm.booking.pickup_location, -1)"
            >mdi-map-marker</v-icon
          ></v-flex
        >
        <v-flex md6>
          <BookingLocationInput
            flatField
            @locationChanged="pickupUpdated"
            v-model="bookingForm.booking.pickup_location"
            label="Pickup Location"
            :id="keyName + 'pickup'"
            :error="bookingForm.errors.pickup_location"
          />
        </v-flex>
        <v-icon
          style="padding-left: 4px"
          v-if="!pickupInfoActive()"
          class="add-person-button"
          v-on:click="activatePickupInfo"
          >person_add</v-icon
        >
        <v-flex px-1 xs6 md2>
          <SimpleTextInput
            v-if="pickupInfoActive()"
            v-model="bookingForm.booking.pickup_info.name"
            label="Name"
            :error="bookingForm.errors.pickup_info"
          />
        </v-flex>
        <v-flex px-1 xs6 md2>
          <SimpleTextInput
            v-if="pickupInfoActive()"
            v-model="bookingForm.booking.pickup_info.contact_number"
            label="Contact No."
          />
        </v-flex>
        <v-flex px-1 xs12 md2>
          <SimpleTextInput
            v-if="pickupInfoActive()"
            v-model="bookingForm.booking.pickup_info.notes"
            label="Notes"
            :maxlength="300"
          />
        </v-flex>
      </v-layout>
      <v-row pr-1 align-start justify-start>
          <v-col cols="12">
              <draggable v-model="bookingForm.booking.destinations" @change="orderChanged">
                  <v-flex
                      xs12
                      pt-2
                      v-for="(destination, index) in bookingForm.booking.destinations"
                  >
                      <v-list-item py-1 align-start v-if="index > 0">
                          <v-flex shrink>
                              <v-icon small @click="customiseLocationOld(bookingForm.booking.destinations[index], index)">mdi-map-marker</v-icon>
                              <v-icon>mdi-drag</v-icon>
                          </v-flex>
                          <v-flex xs11 md5>
                              <BookingLocationInput
                                  flatField
                                  :removable="true"
                                  @locationChanged="viaUpdated"
                                  v-model="bookingForm.booking.destinations[index]"
                                  :id="keyName + 'destination' + index"
                                  :deletable="index > 0"
                                  @removePressed="removeVia(index)"
                                  :label="index == 0 ? 'Destination' : 'Via ' + index"
                                  :error="bookingForm.errors[`destination_${index}`]"
                              />
                          </v-flex>
                          <v-icon
                              v-if="!viaActive(bookingForm.booking.via_info[index - 1])"
                              class="add-person-button"
                              v-on:click="activateViaInfo(index)"
                          >person_add</v-icon
                          >
                          <v-flex
                              px-1
                              v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                              xs6
                              md2
                          >
                              <SimpleTextInput
                                  v-model="bookingForm.booking.via_info[index - 1].name"
                                  label="Name"
                                  :error="bookingForm.errors[`via_info_${index - 1}`]"
                              />
                          </v-flex>
                          <v-flex
                              px-1
                              v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                              xs6
                              md2
                          >
                              <SimpleTextInput
                                  v-model="bookingForm.booking.via_info[index - 1].contact_number"
                                  label="Contact No."
                              />
                          </v-flex>
                          <v-flex
                              px-1
                              v-if="viaActive(bookingForm.booking.via_info[index - 1])"
                              xs12
                              md2
                          >
                              <SimpleTextInput
                                  v-model="bookingForm.booking.via_info[index - 1].notes"
                                  label="Notes"
                                  :maxlength="300"
                              />
                          </v-flex>
                      </v-list-item>
                  
                  </v-flex>
              </draggable>
          </v-col>
      </v-row>
      <v-row px-1 align-start>
        <v-flex pt-1 shrink
          ><v-icon
            v-on:click="customiseLocationOld(bookingForm.booking.destinations[0], 0)"
            >mdi-map-marker</v-icon
          ></v-flex
        >
        <v-flex md6 pt-2>
          <BookingLocationInput
            flatField
            @locationChanged="destinationUpdated"
            v-model="bookingForm.booking.destinations[0]"
            label="Destination Location"
            :id="keyName + 'destination'"
            :error="bookingForm.errors['destination_0']"
          />
        </v-flex>
        <v-flex pt-2 v-if="!destinationInfoActive()">
          <v-icon
            style="padding-left: 4px"
            class="add-person-button"
            v-on:click="activateDestinationInfo()"
            >person_add</v-icon
          >
        </v-flex>
        <v-flex px-1 v-if="destinationInfoActive()" xs6 md2 pt-2>
          <SimpleTextInput
            v-model="bookingForm.booking.destination_info.name"
            label="Name"
            :error="bookingForm.errors.destination_info"
          />
        </v-flex>
        <v-flex px-1 v-if="destinationInfoActive()" xs6 md2 pt-2>
          <SimpleTextInput
            v-model="bookingForm.booking.destination_info.contact_number"
            label="Contact No."
          />
        </v-flex>
        <v-flex px-1 pt-2 md2>
          <SimpleTextInput
            v-if="destinationInfoActive()"
            v-model="bookingForm.booking.destination_info.notes"
            label="Notes"
            :maxlength="300"
          />
        </v-flex>
      </v-row>
      <v-layout px-1 pr-2 row wrap justify-end style="width: 100%">
        <v-btn @click="addVia()" small text class="text-none">+ Via</v-btn>
        <v-btn @click="showFullMap()" small text class="text-none"><v-icon>mdi-map-marker</v-icon> View Map</v-btn>
      </v-layout>
      <v-flex px-2 pt-2>
        <v-layout row>
          <v-divider style="margin-left: 12px; margin-top: 2px"></v-divider>
        </v-layout>
      </v-flex>
      <v-flex pt-1>
        <VehicleRequirementsInput :bookingForm="bookingForm" />
      </v-flex>
      <v-flex>
        <PassengerFindDetails :bookingForm="bookingForm" />
      </v-flex>
      <v-flex>
        <BookingDispatchInput :bookingForm="bookingForm" />
      </v-flex>
      <v-flex px-2>
        <v-layout row>
          <v-divider style="margin-left: 12px; margin-top: 2px"></v-divider>
        </v-layout>
      </v-flex>
      <v-flex pt-1>
        <PaymentInput :bookingForm="bookingForm" :hideAdditionalCharge="true" />
      </v-flex>
      <v-flex>
        <UserNotes :bookingForm="bookingForm" :hideCustomer="true" />
      </v-flex>

    <RepeatTripOptions
      @update="update"
      @create="create"
      @addReturnTrip="addReturnTrip"
      @cancel="cancel"
      @alter="alter"
      :repeatService="repeatService"
      :updateMode="updateMode"
      :bookingForm="bookingForm"
      :alterMode="alterMode"
      :loading="loading"
      :repeatTripDefinition="repeatTripDefinition"
    />
    <v-dialog v-model="customLocationDialog" width="800">
      <div v-if="location != null" style="background-color: white">
        <v-flex pa-3>
          <v-col>
            <p>Drag marker on the map to update the location</p>
            <!-- <v-text-field
              v-model="location.description"
              label="Location Name"
            ></v-text-field> -->
            <v-card style="height: 600px; width: 750px">
              <GmapMap
                ref="mapRef"
                :center="location.position == null ? center : location.position"
                :zoom="11.5"
                class="mapCircle"
                style="height: 100%; width: 100%"
                :options="{
                  zoomControl: false,
                  mapTypeControl: true,
                  scaleControl: false,
                  streetViewControl: true,
                  rotateControl: false,
                  fullscreenControl: true,
                  disableDefaultUi: false,
                }"
              >
                  <GmapMarker
                      v-for="(location, index) in locations"
                      :key="index"
                      :position="location.position"
                      :clickable="false"
                      :draggable="true"
                      :icon="location.icon"
                      :zIndex="12"
                      @dragend="markerMoved(location, index, $event.latLng)"
                  />
              </GmapMap>
            </v-card>
            <v-flex pt-3>
              <v-row justify="end">
                <v-flex shrink px-2>
                  <v-btn @click="customLocationDialog = false">Cancel</v-btn>
                </v-flex>
                <v-btn @click="submitLocation">Confirm</v-btn>
              </v-row>
            </v-flex>
          </v-col>
        </v-flex>
      </div>
    </v-dialog>
  </v-col>
  </v-col>
</template>

<script>
import axios from "axios";
import draggable from 'vuedraggable'

import BookingLocationInput from "@/components/widget/input/BookingLocationInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import BookingDateTimeInput from "@/components/widget/input/BookingDateTimeInput.vue";

import BookingDispatchInput from "@/components/widget/input/BookingDispatchInput.vue";
import BusinessCustomerDetailsInput from "@/components/widget/input/BusinessCustomerDetailsInput.vue";
import VehicleRequirementsInput from "@/components/widget/input/VehicleRequirementsInput.vue";
import PassengerFindDetails from "@/components/widget/input/PassengerFindDetails.vue";
import PaymentInput from "@/components/widget/input/PaymentInput.vue";
import CardInput from "@/components/widget/input/CardInput.vue";
import PromocodeInput from "@/components/widget/input/PromocodeInput.vue";

import CustomerSearchInput from "@/components/widget/input/CustomerSearchInput.vue";
import UserNotes from "@/components/widget/input/UserNotes.vue";
import BookTripETARoute from "@/components/widget/input/BookTripETARoute.vue";

import RepeatTripOptions from "@/components/repeat_service/RepeatTripOptions.vue";
import {gmapApi} from "vue2-google-maps";

axios.defaults.withCredentials = true;

export default {
  name: "TripForm",
  model: {
    prop: "content",
    event: "input",
  },
  components: {
      draggable,
    BookingLocationInput,
    SimpleTextInput,
    BookingDispatchInput,
    SelectableInput,
    BookingDateTimeInput,
    BusinessCustomerDetailsInput,
    VehicleRequirementsInput,
    PassengerFindDetails,
    PaymentInput,
    CustomerSearchInput,
    UserNotes,
    BookTripETARoute,
    CardInput,
    PromocodeInput,
    RepeatTripOptions,
  },
  props: {
    repeatTripDefinition: Object,
    repeatBookingForm: Object,
    repeatService: Object,
    expand: Function,
    updateMode: {
      type: Boolean,
      default: false,
    },
    alterMode: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    keyName: String,
  },
  mounted: function() {
    this.bookingForm = this.repeatBookingForm;

    var geocoder = new google.maps.Geocoder();

    this.geocoder = geocoder;
  },
  computed: {
    google: gmapApi,
    userIsBusiness: function () {
      console.log("User is business " + this.bookingForm.user.business == true);
      return this.bookingForm.user.business == true;
    },
    viaCount: function () {
      var count = 0;

      for (var i = 1; i < this.bookingForm.booking.destinations.length; i++) {
        if (this.bookingForm.booking.destinations[i].id != null) {
          count++;
        }
      }

      return count;
    },
  },
  data() {
    return {
      bookingForm: {},
      customLocationDialog: false,
      addingCard: false,
      addingPromocode: false,
      location: null,
      locationToUpdate: null,
      center: this.$store.state.center,
      locations: [],
      locationsToUpdate: [],
      geocoder: null,
    };
  },
  watch: {
      "bookingForm.booking.destinations" (newDestinatons, oldDestinations) {
          oldDestinations.forEach((oldDestination,index) => {
              oldDestination.via_info = this.bookingForm.booking.via_info[index]
          })
          
          //rearrange viaInfos for new destinations
          newDestinatons.forEach(newDestination => {
              let oldDestinationPoint = oldDestinations.find(oldDestination => {
                  return oldDestination.id == newDestination.id
              })
              if (oldDestinationPoint) {
                  newDestination.via_info = oldDestinationPoint.via_info
              }
          })
          // this.bookingForm.booking.via_info = newDestinatons.map(newDestination => {
          //     return newDestination.via_info
          // })
          this.$forceUpdate()
        console.log('new destinations', newDestinatons)
        console.log('old destinations', oldDestinations)
      }
  },
  methods: {
      rearrange(oldIndex, newIndex) {
          if (oldIndex < 0 || oldIndex >= this.bookingForm.booking.via_info.length || newIndex < 0 || newIndex >= this.bookingForm.booking.via_info.length) {
              console.error("Invalid index");
              return;
          }
          
          const [movedItem2] = this.bookingForm.booking.via_info.splice(oldIndex, 1);
          this.bookingForm.booking.via_info.splice(newIndex, 0, movedItem2);
      },
      swapViaPoints (index1, index2) {
          console.log('new index', index1-1)
          console.log('old index', index2-1)
          const temp = this.bookingForm.booking.via_info[index1];
          console.log('temp via info', temp)
          this.bookingForm.booking.via_info[index1] = this.bookingForm.booking.via_info[index2];
          this.bookingForm.booking.via_info[index2] = temp;
      },
      orderChanged(event) {
          const oldIndex = event.moved.oldIndex;
          const newIndex = event.moved.newIndex;
          console.log('old index', oldIndex)
          console.log('new index', newIndex)
          this.rearrange(oldIndex -1, newIndex-1)
          // this.swapViaPoints(event.moved.newIndex, event.moved.oldIndex)
          console.log('got change event', event.moved.oldIndex)
        // alert('via points order changed')
      },
    markerMoved: function (currentLocation, index, loc) {

      var vm = this;
      console.log("Marker moved");
      // console.log(latLng);
      console.log("index: ", index);
      console.log("locationIndex: ", currentLocation.index);

      loc = JSON.parse(JSON.stringify(loc));

      this.geocoder.geocode({ location: loc }, function (
          results,
          status
      ) {
        if (status === "OK") {
          console.log(results);

          let addressComponents = {
            street_number: "short_name",
            route: "long_name",
            locality: "long_name",
            administrative_area_level_1: "short_name",
            country: "long_name",
            postal_code: "short_name",
          };
          let returnData = {};

          var place = results[0];

          if (place.address_components !== undefined) {
            // Get each component of the address from the place details
            for (let i = 0; i < place.address_components.length; i++) {
              let addressType = place.address_components[i].types[0];
              if (addressComponents[addressType] != undefined) {
                let val =
                    place.address_components[i][
                        addressComponents[addressType]
                        ];
                returnData[addressType] = val;
              }
            }

            returnData["latitude"] = place.geometry.location.lat();
            returnData["longitude"] = place.geometry.location.lng();
            // return returnData object and PlaceResult object

            var address = place.formatted_address;

            if (
                place.types.includes("establishment") &&
                place.name !== "undefined" &&
                place.name !== undefined
            ) {
              // console.log("PLACE NAME " + place.name);
              address = place.name + ", " + address;
            }

            vm.locationsToUpdate[index] = {
              index: currentLocation.index,
              description: address,
              lat: loc.lat,
              lng: loc.lng,
            };
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      });

      // this.location.position = { lat: position.lat(), lng: position.lng() };
    },
    sendLocationToServer(latitude, longitude, description, index, success) {
      axios({
        url: `${this.$store.state.apiUrl}/location/add`,
        method: "POST",
        params: {
          lat: latitude,
          lon: longitude,
          description: description,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {
          // console.log(res.data);
          var loc = {
            id: res.data.id,
            description: res.data.description,
            latLng: {
              latitude: res.data.lat,
              longitude: res.data.lon,
            },
          };

          success(loc, index);
        })
        .catch((err) => console.error(err));
    },
    submitLocation() {
      var vm = this;

      this.locationsToUpdate.forEach((loc) => {
        console.log("loc: ", loc);
        this.sendLocationToServer(
          loc.lat,
          loc.lng,
          loc.description,
          loc.index,
          function (loc, index) {
            let updatedLocation = {};
            updatedLocation.description = loc.description;
            updatedLocation.latLng = loc.latLng;
            updatedLocation.id = loc.id;

            if(index === -1) {
              vm.bookingForm.booking.pickup_location = updatedLocation;
            }
            else {
              vm.bookingForm.booking.destinations[index] = updatedLocation;
            }

            vm.customLocationDialog = false;
          }
        );
      });

      // this.locationToUpdate = null;
      this.locationsToUpdate = [];

    },
    customiseLocationOld(loc, index) {
      this.locationToUpdate = loc;
      this.location = JSON.parse(JSON.stringify(loc));

      if (this.location.latLng == null) {
        console.log("No latlng");
        this.location.position = JSON.parse(JSON.stringify(this.center));
      } else {
        console.log("Latlng");
        console.log(this.location.latLng);
        this.location.position = {
          lat: this.location.latLng.latitude,
          lng: this.location.latLng.longitude,
        };
      }

      this.location.index = index;

      this.locations = [this.location];

      this.customLocationDialog = true;
    },
    showFullMap: function () {
        this.locations = [];
        this.locationsToUpdate = [];

      // this.location = JSON.parse(JSON.stringify(this.bookingForm.booking.destinations));
      const pl = this.bookingForm.booking.pickup_location;
      this.location = {
        ...pl,
        position: {
          lat: pl.latLng.latitude,
          lng: pl.latLng.longitude
        },
        icon: {
          url: "/img/map/pickup_marker.png",
          anchor: new google.maps.Point(16, 16),
        },
        zIndex: 12,
        index: -1
      }

      this.locations.push(this.location);

      let destination = this.bookingForm.booking.destinations[0];

      this.locations.push({
        ...destination,
        position: {
          lat: destination.latLng.latitude,
          lng: destination.latLng.longitude
        },
        icon: {
          url: "/img/map/destination_marker.png",
          anchor: new google.maps.Point(13, 32),
        },
        zIndex: 12,
        index: 0
      });

      for (var i = 1; i < this.bookingForm.booking.destinations.length; i++) {
        let loc = this.bookingForm.booking.destinations[i];

        if (loc.latLng == null) {
          this.locations.push(
              {
                ...loc,
                position: JSON.parse(JSON.stringify(this.center))
              }
          )
        } else {
          this.locations.push(
              {
                ...loc,
                position: {
                  lat: loc.latLng.latitude,
                  lng: loc.latLng.longitude
                },
                icon: {
                  url: `/img/map/pin_${i}.png`,
                  anchor: new google.maps.Point(14, 34),
                },
                zIndex: 12,
                index: i
              }
          )
        }
      }

      this.customLocationDialog = true;
    },
    cancel: function () {
      this.$emit("cancel", null);
    },
    addReturnTrip: function () {
      this.$emit("addReturnTrip", null);
    },
    create: function () {
      if (this.bookingForm.validateRide()) {

        if (this.bookingForm.booking.final_fare == null) {
          alert("Please enter a final fare");
          return;
        }
        
        this.$emit("create", null);
      }
    },
    alter: function () {
      if (this.bookingForm.validateRide()) {
        this.$emit("alter", null);
      }
    },
    update: function () {
      if (this.bookingForm.validateRide()) {
        this.$emit("update", null);
      }
    },
    activatePickupInfo: function () {
      this.bookingForm.booking.pickup_info.active = true;
    },
    pickupInfoActive: function () {
      return (
        this.bookingForm.booking.pickup_info != null &&
        this.bookingForm.booking.pickup_info.active == true
      );
    },
    activateDestinationInfo: function () {
      this.bookingForm.booking.destination_info.active = true;
    },
    destinationInfoActive: function () {
      return (
        this.bookingForm.booking.destination_info != null &&
        this.bookingForm.booking.destination_info.active == true
      );
    },
    addVia: function () {
      this.bookingForm.addVia();
    },
    getCostEstimate: function (loc) {
      console.log("Get cost estimate smallbookform");
      this.bookingForm.getCostEstimate();
    },
    pickupUpdated: function (loc) {
      this.bookingForm.booking.pickup_location = loc;
      this.getCostEstimate();

      // this.centerToBooking();
      // this.$emit("locationsChanged", "");
    },
    destinationUpdated: function (loc) {
      this.bookingForm.booking.destinations[0] = loc;
      this.getCostEstimate();

      // this.centerToBooking();
      // this.$emit("locationsChanged", "");
    },
    viaUpdated: function (loc) {
      // this.centerToBooking();
      // this.$emit("locationsChanged", "");

      this.getCostEstimate();
    },
    viaActive: function (via) {
          if(!via) {
              return false
          }
          console.log('got via info', via)
      return via.active != null && via.active == true;
    },
    removeVia: function (index) {
      this.bookingForm.booking.destinations.splice(index, 1);
      this.bookingForm.booking.via_info.splice(index - 1, 1);

      this.getCostEstimate();

      this.centerToBooking();
      this.$emit("locationsChanged", "");
    },
    activateViaInfo: function (index) {
          if (this.bookingForm.booking.via_info[index - 1]) {
              this.bookingForm.booking.via_info[index - 1].active = true;
              this.$forceUpdate();
          }
    },
    changePaymentTypeToCardWithToken(token) {
      this.addingCard = false;
      this.bookingForm.changePaymentType("card", token.card.id);
    },
    changePromocode(promocode) {
      this.addingPromocode = false;
      this.bookingForm.changePromocode(promocode);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: #10425a;
}

.v-input--selection-controls {
  margin-top: 6px !important;
  padding-top: 0px !important;
}


.v-input__append-outer {
  padding-left: 0px !important;
  margin-left: 0px !important;
}

.small-button {
  font-size: 12px !important;
}
</style>
